import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ContactSection } from '../components/sections/ContactSection';
export function Contact() {
  return <>
      <PageHeader eyebrow="Contact" title="Contact information for Atlas Digital Hub" description="We answer questions about our business, purchases, digital delivery and our published policies by email." data-id="element-206" data-mp="1qpcu65dgajrd" />
      <ContactSection data-id="element-207" data-mp="y1qu373flx99" />
    </>;
}